import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { useRouteMatch } from 'react-router';
import useSWR from 'swr';
import { OutpostAttempt, OutpostDestination, OutpostDestinationTypeMetadata } from '../../../../../../../typings/outpost';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import Badge from '../../../common/base/Badge';
import { StyledCard } from '../../../common/base/Card';
import Chip from '../../../common/base/Chip';
import Loading from '../../../common/base/Loading';
import Text from '../../../common/base/Text';
import DisplayDate from '../../../common/DisplayDate';
import { Div } from '../../../common/helpers/StyledUtils';
import JSONBrowser from '../../../common/JSONBrowser';
import Table from '../../../common/Table/Table';
import { GlobalContext } from '../../../contexts/GlobalContext';
import { StyledViewContent, StyledViewLayout, StyledViewNav, StyledViewNavHeader, StyledViewSplitPaneContent, StyledViewSplitPaneLayout, StyledViewSplitPaneSection, StyledViewSplitPaneSidebar, StyledViewSplitPaneSidebarBody, ViewBreadcrumbsTitle, ViewMetadataDate, ViewMetadataItem, ViewSplitPaneContentHeader, ViewSplitPaneSidebarHeader } from '../../../layouts/ViewLayout';
import NotFound from '../../DashboardScene/NotFound';
import FullscreenLayout from '../../../layouts/FullscreenLayout';
import { capitalizeFirstLetter } from '../../../../utils';
import { DestinationTypeIcon } from '../Destinations/DestinationTypeIcon';
import { OUTPOST_ATTEMPT_INCLUDES } from '../Attempts/utils';
import { getOutpostTenantLabel, useOutpostTenantsById } from '../utils/tenantDisplay';
import { DashboardContext } from '../../DashboardScene/DashboardContext';
const OperatorEventView = () => {
  const $ = _c(91);
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    is_degraded_banner_active
  } = useContext(DashboardContext);
  const {
    params: t0
  } = useRouteMatch();
  const {
    event_id
  } = t0;
  let t1;
  if ($[0] !== event_id) {
    t1 = APIMethodKeys.outpost.operatorEvents.events.get(event_id);
    $[0] = event_id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== HookdeckAPI.outpost.operatorEvents.events || $[3] !== event_id) {
    t2 = () => HookdeckAPI.outpost.operatorEvents.events.get(event_id);
    $[2] = HookdeckAPI.outpost.operatorEvents.events;
    $[3] = event_id;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data: event,
    error: event_error
  } = useSWR(t1, t2);
  let t3;
  if ($[5] !== event || $[6] !== event_id) {
    t3 = event ? APIMethodKeys.outpost.operatorEvents.events.listAttempts(event_id) : null;
    $[5] = event;
    $[6] = event_id;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== HookdeckAPI.outpost.operatorEvents.attempts || $[9] !== event_id) {
    t4 = () => HookdeckAPI.outpost.operatorEvents.attempts.list({
      event_id,
      include: OUTPOST_ATTEMPT_INCLUDES
    });
    $[8] = HookdeckAPI.outpost.operatorEvents.attempts;
    $[9] = event_id;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const {
    data: attempts,
    isLoading: attempts_loading
  } = useSWR(t3, t4);
  let t5;
  if ($[11] !== event) {
    t5 = event ? APIMethodKeys.outpost.operatorEvents.destinations.list() : null;
    $[11] = event;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== HookdeckAPI.outpost.operatorEvents.destinations) {
    t6 = () => HookdeckAPI.outpost.operatorEvents.destinations.list();
    $[13] = HookdeckAPI.outpost.operatorEvents.destinations;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const {
    data: destinations
  } = useSWR(t5, t6);
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = APIMethodKeys.outpost.destinationTypes.list();
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== HookdeckAPI.outpost.destinationTypes) {
    t8 = () => HookdeckAPI.outpost.destinationTypes.list();
    $[16] = HookdeckAPI.outpost.destinationTypes;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const {
    data: destination_types
  } = useSWR(t7, t8);
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      label: "Operator Events",
      to: "/operator-events"
    };
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== event_id) {
    t10 = [t9, {
      label: event_id,
      highlight: true
    }];
    $[19] = event_id;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const breadcrumbs = t10;
  const payload = event?.data?.data ?? event?.data;
  const tenant_id = event?.data?.tenant_id || payload?.destination?.tenant_id;
  let t11;
  if ($[21] !== tenant_id) {
    t11 = [tenant_id];
    $[21] = tenant_id;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const {
    tenants_by_id
  } = useOutpostTenantsById(t11);
  if (event_error && event_error?.status === 404) {
    let t12;
    if ($[23] !== event_id) {
      t12 = <NotFound title="Operator event not found" description="This operator event does not exist or has been deleted." id={event_id} />;
      $[23] = event_id;
      $[24] = t12;
    } else {
      t12 = $[24];
    }
    return t12;
  }
  if (!event || !destinations || !attempts || !destination_types) {
    let t12;
    if ($[25] !== breadcrumbs) {
      t12 = <StyledViewNav><StyledViewNavHeader><ViewBreadcrumbsTitle breadcrumbs={breadcrumbs} /></StyledViewNavHeader></StyledViewNav>;
      $[25] = breadcrumbs;
      $[26] = t12;
    } else {
      t12 = $[26];
    }
    let t13;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <FullscreenLayout light={true} center={true} no_decorations={true}><Loading /></FullscreenLayout>;
      $[27] = t13;
    } else {
      t13 = $[27];
    }
    let t14;
    if ($[28] !== t12) {
      t14 = <StyledViewLayout><StyledViewContent>{t12}{t13}</StyledViewContent></StyledViewLayout>;
      $[28] = t12;
      $[29] = t14;
    } else {
      t14 = $[29];
    }
    return t14;
  }
  let t12;
  if ($[30] !== destinations) {
    t12 = (destinations || []).reduce(_temp, {} as Record<string, OutpostDestination>);
    $[30] = destinations;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  const destinations_by_id = t12;
  let t13;
  if ($[32] !== destination_types) {
    t13 = (destination_types || []).reduce(_temp2, {} as Record<string, OutpostDestinationTypeMetadata>);
    $[32] = destination_types;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  const destination_types_by_type = t13;
  let t14;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = ["Timestamp", "Response Status", "Destination"];
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  const delivery_headers = t14;
  let t15;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = [{
      min: 188,
      max: 188
    }, {
      min: 120,
      max: 120
    }, {
      min: 200
    }];
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  const delivery_widths = t15;
  let t16;
  if ($[36] !== attempts?.models) {
    t16 = attempts?.models || [];
    $[36] = attempts?.models;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== destination_types_by_type || $[39] !== destinations_by_id || $[40] !== t16) {
    let t18;
    if ($[42] !== destination_types_by_type || $[43] !== destinations_by_id) {
      t18 = attempt => ({
        id: attempt.id,
        fields: [<DisplayDate key={`${attempt.id}-time`} date={attempt.time} show_timezone={false} />, <Badge key={`${attempt.id}-status`} success={attempt.status === "success"} danger={attempt.status === "failed"} subtle={true}>{capitalizeFirstLetter(attempt.status)} {attempt.code ? `(${attempt.code})` : ""}</Badge>, attempt.destination_id ? <>{destinations_by_id[attempt.destination_id] ? <Div key={`${attempt.id}-dest`} flex={{
            align: "center",
            gap: 2
          }}><DestinationTypeIcon small={true} type_meta={destination_types_by_type[destinations_by_id[attempt.destination_id].type]} type={destinations_by_id[attempt.destination_id].type} /><Text size="s" semi={true} ellipsis={true}>{destination_types_by_type[destinations_by_id[attempt.destination_id].type].label}{" "}⋅{" "}</Text><Text size="s" ellipsis={true}>{destinations_by_id[attempt.destination_id]?.target}</Text></Div> : <Text key={`${attempt.id}-dest-deleted`} size="s" color="muted">Destination Deleted</Text>}</> : "\u2014"]
      });
      $[42] = destination_types_by_type;
      $[43] = destinations_by_id;
      $[44] = t18;
    } else {
      t18 = $[44];
    }
    t17 = t16.map(t18);
    $[38] = destination_types_by_type;
    $[39] = destinations_by_id;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  const delivery_rows = t17;
  let t18;
  if ($[45] !== breadcrumbs) {
    t18 = <StyledViewNav><StyledViewNavHeader><ViewBreadcrumbsTitle breadcrumbs={breadcrumbs} /></StyledViewNavHeader></StyledViewNav>;
    $[45] = breadcrumbs;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <ViewSplitPaneSidebarHeader title="Operator event details" />;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== tenant_id || $[49] !== tenants_by_id) {
    t20 = <ViewMetadataItem label="Tenant">{tenant_id ? <Chip outline={true} label={getOutpostTenantLabel(tenant_id, tenants_by_id[tenant_id])} to={`/tenants/${tenant_id}`} /> : <Text muted={true}>—</Text>}</ViewMetadataItem>;
    $[48] = tenant_id;
    $[49] = tenants_by_id;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  let t21;
  if ($[51] !== payload || $[52] !== tenant_id) {
    t21 = <ViewMetadataItem label="Destination">{payload?.destination ? <Chip mono={true} outline={true} label={payload.destination.id} to={`/tenants/${tenant_id}/destinations/${payload.destination.id}`} /> : <Text muted={true}>—</Text>}</ViewMetadataItem>;
    $[51] = payload;
    $[52] = tenant_id;
    $[53] = t21;
  } else {
    t21 = $[53];
  }
  let t22;
  if ($[54] !== event.topic) {
    t22 = <ViewMetadataItem label="Topic"><Text mono={true} size="s">{event.topic}</Text></ViewMetadataItem>;
    $[54] = event.topic;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  let t23;
  if ($[56] !== event.topic || $[57] !== payload) {
    t23 = event.topic === "alert.destination.consecutive_failure" && <ViewMetadataItem label="Threshold"><Text mono={true}>{payload?.consecutive_failures?.threshold != null ? `${payload.consecutive_failures.threshold}%` : "\u2014"}</Text></ViewMetadataItem>;
    $[56] = event.topic;
    $[57] = payload;
    $[58] = t23;
  } else {
    t23 = $[58];
  }
  let t24;
  if ($[59] !== event.time) {
    t24 = <ViewMetadataItem label="Timestamp"><ViewMetadataDate date={event.time} /></ViewMetadataItem>;
    $[59] = event.time;
    $[60] = t24;
  } else {
    t24 = $[60];
  }
  let t25;
  if ($[61] !== t20 || $[62] !== t21 || $[63] !== t22 || $[64] !== t23 || $[65] !== t24) {
    t25 = <StyledViewSplitPaneSidebar><StyledViewSplitPaneSidebarBody>{t19}{t20}{t21}{t22}{t23}{t24}</StyledViewSplitPaneSidebarBody></StyledViewSplitPaneSidebar>;
    $[61] = t20;
    $[62] = t21;
    $[63] = t22;
    $[64] = t23;
    $[65] = t24;
    $[66] = t25;
  } else {
    t25 = $[66];
  }
  let t26;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <ViewSplitPaneContentHeader title="Event data" />;
    $[67] = t26;
  } else {
    t26 = $[67];
  }
  let t27;
  if ($[68] !== event.data) {
    t27 = event.data || {};
    $[68] = event.data;
    $[69] = t27;
  } else {
    t27 = $[69];
  }
  let t28;
  if ($[70] !== t27) {
    t28 = <StyledViewSplitPaneSection>{t26}<StyledCard overflow_hidden={true} p={4}><JSONBrowser json={t27} /></StyledCard></StyledViewSplitPaneSection>;
    $[70] = t27;
    $[71] = t28;
  } else {
    t28 = $[71];
  }
  const t29 = attempts?.models.length ?? 0;
  let t30;
  if ($[72] !== t29) {
    t30 = <ViewSplitPaneContentHeader title="Event deliveries" elements={<Badge neutral={true} subtle={true}>{t29}</Badge>} />;
    $[72] = t29;
    $[73] = t30;
  } else {
    t30 = $[73];
  }
  const t31 = attempts?.models.length;
  let t32;
  if ($[74] !== attempts_loading || $[75] !== delivery_rows || $[76] !== t31) {
    t32 = <StyledCard overflow_hidden={true}><Table headers={delivery_headers} widths={delivery_widths} rows={delivery_rows} loading={attempts_loading} current_count={t31} footer={false} /></StyledCard>;
    $[74] = attempts_loading;
    $[75] = delivery_rows;
    $[76] = t31;
    $[77] = t32;
  } else {
    t32 = $[77];
  }
  let t33;
  if ($[78] !== t30 || $[79] !== t32) {
    t33 = <StyledViewSplitPaneSection>{t30}{t32}</StyledViewSplitPaneSection>;
    $[78] = t30;
    $[79] = t32;
    $[80] = t33;
  } else {
    t33 = $[80];
  }
  let t34;
  if ($[81] !== t28 || $[82] !== t33) {
    t34 = <StyledViewSplitPaneContent>{t28}{t33}</StyledViewSplitPaneContent>;
    $[81] = t28;
    $[82] = t33;
    $[83] = t34;
  } else {
    t34 = $[83];
  }
  let t35;
  if ($[84] !== is_degraded_banner_active || $[85] !== t25 || $[86] !== t34) {
    t35 = <StyledViewSplitPaneLayout banner_active={is_degraded_banner_active} nav_height={53}>{t25}{t34}</StyledViewSplitPaneLayout>;
    $[84] = is_degraded_banner_active;
    $[85] = t25;
    $[86] = t34;
    $[87] = t35;
  } else {
    t35 = $[87];
  }
  let t36;
  if ($[88] !== t18 || $[89] !== t35) {
    t36 = <StyledViewLayout><StyledViewContent>{t18}{t35}</StyledViewContent></StyledViewLayout>;
    $[88] = t18;
    $[89] = t35;
    $[90] = t36;
  } else {
    t36 = $[90];
  }
  return t36;
};
export default OperatorEventView;
function _temp(acc, destination) {
  acc[destination.id] = destination;
  return acc;
}
function _temp2(acc_0, dt) {
  acc_0[dt.type] = dt;
  return acc_0;
}